/**
 * @type {{short: import("~types/types").AppLocale, longDash: string, longUnderscore: string}[]}
 */
const locales = [
  {
    short: "nl",
    longDash: "nl-NL",
    longUnderscore: "nl_NL",
  },
  {
    short: "en",
    longDash: "en-GB",
    longUnderscore: "en_GB",
  },
  {
    short: "fr",
    longDash: "fr-FR",
    longUnderscore: "fr_FR",
  },
  {
    short: "de",
    longDash: "de-DE",
    longUnderscore: "de_DE",
  },
  {
    short: "es",
    longDash: "es-ES",
    longUnderscore: "es_ES",
  },
  {
    short: "it",
    longDash: "it-IT",
    longUnderscore: "it_IT",
  },
  {
    short: "pt",
    longDash: "pt-PT",
    longUnderscore: "pt_PT",
  },
];

function findLocaleConfig(locale) {
  return locales.find((value) => Object.values(value).includes(locale));
}

/**
 *
 * @param {string} locale - can be either short or long locale (eg: nl or nl-NL or nl_NL)
 * @returns {import("~types/types").AppLocale|null}
 * @example
 * toShortLocale("nl") // "nl"
 * toShortLocale("nl-NL") // "nl"
 * toShortLocale("nl_NL") // "nl"
 */
function toShortLocale(locale) {
  const localeConfig = locales.find((value) =>
    Object.values(value).includes(locale),
  );
  if (!localeConfig) {
    return null;
  }
  return localeConfig.short;
}

/**
 * @param {string} locale - can be either short or long locale
 * @returns {string|null}
 * @example
 * toShortLocaleUpperCase("nl") // "NL"
 * toShortLocaleUpperCase("nl-NL") // "NL"
 * toShortLocaleUpperCase("nl_NL") // "NL"
 */
function toShortLocaleUpperCase(locale) {
  return toShortLocale(locale)?.toUpperCase() ?? null;
}

/**
 *
 * @param {string} locale - can be either short or long locale
 * @returns {string|null}
 * @example
 * toLongUnderscoreLocale("nl") // "nl_NL"
 * toLongUnderscoreLocale("nl-NL") // "nl_NL"
 * toLongUnderscoreLocale("nl_NL") // "nl_NL"
 */
function toLongUnderscoreLocale(locale) {
  const localeConfig = findLocaleConfig(locale);
  if (!localeConfig) {
    return null;
  }
  return localeConfig.longUnderscore;
}

/**
 *
 * @param {string} locale - can be either short or long locale
 * @returns {string|null}
 * @example
 * toLongDashLocale("nl") // "nl-NL"
 * toLongDashLocale("nl-NL") // "nl-NL"
 * toLongDashLocale("nl_NL") // "nl-NL"
 */
function toLongDashLocale(locale) {
  const localeConfig = findLocaleConfig(locale);
  if (!localeConfig) {
    return null;
  }
  return localeConfig.longDash;
}

// aliases for actual usage in our project
/**
 * @returns {import("~types/types").AppLocale}
 */
const toAppLocale = toShortLocale;
const toMollieLocale = toLongUnderscoreLocale;
const toPreprLocale = toLongDashLocale;
const toCardApiLocale = toShortLocaleUpperCase;

const localeConverter = {
  toAppLocale,
  toPreprLocale,
  toMollieLocale,
  toCardApiLocale,
};

module.exports = localeConverter;
